import { render, staticRenderFns } from "./ImpresionEquipajeExtra.vue?vue&type=template&id=8fa69dc0&scoped=true&"
import script from "./ImpresionEquipajeExtra.vue?vue&type=script&lang=js&"
export * from "./ImpresionEquipajeExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa69dc0",
  null
  
)

export default component.exports